// services/videoService.js
export const VideoService = {
  async branchToVideo(token, time = 0, { router, player, playback, video, ann, leadCapture }) {
    log.info(2,"⭐️ VideoService branchToVideo", token, time)
    if (!token) {
      log.info(2,"🔴 VideoService branchToVideo: no token provided")
      return
    }
    // Used to keep track of the time for "back" navigations
    let preBranchVideoTime = player.fulltime
    player.pause()


    // Branch to URL, based on playback state
    const url = playback.started ? `/w/${token}` : `/videos/${token}`
    // Finish current playback tracking
    playback.finishTracking()

    // Set reference for potential "back" navigation
    let oldToken = video.video.token

    // Prepare player state
    player.branchTransition = video.video.design.switch_transition

    // Patch transitions for old versions
    if (player.branchTransition == 'left') {
      player.branchTransition = 'slideLeft'
    }
    if (player.branchTransition == 'right') {
      player.branchTransition = 'slideRight'
    }
    if (player.branchTransition == 'up') {
      player.branchTransition = 'slideUp'
    }
    if (player.branchTransition == 'down') {
      player.branchTransition = 'slideDown'
    }

    player.branchCount = 1

    // Can't take screenshot of youtube videos, so we branch immediately
    let isYoutube = video.video.source.type_of === 'youtube'
    if (isYoutube) {
      player.branching = true
    } else {
      player.takeScreenshot()
      .then(() => {
        log.info(2,"🔄 VideoService branchToVideo screenshot taken")
        player.branching = true
      })
      .catch((error) => {
        log.info(2,"⚠️ VideoService branchToVideo screenshot failed:", error.message)
        player.branching = true // Continue with branch anyway
      })
    }

    try {
      let oldId = video.video.id
      let oldToken = video.video.token
      ann.resetState()
      log.info(2,"🔄 VideoService branchToVideo going to show", token, { manage: video.video.manage })
      video.show(token, { manage: video.video.manage }).then(() => {
        playback.refer_time = preBranchVideoTime
        log.info(2,"🔄 VideoService branchToVideo show done, refer_time:", preBranchVideoTime)
        if (oldId == video.video.id) {
          log.info(2,"🔄 VideoService branchToVideo id not changed", oldId, video.video.id, ann.pausedInteraction)
          player.branching = false
          if (ann.pausedInteraction) {
            log.info(2,"🔄 VideoService branchToVideo pausedInteraction", ann.pausedInteraction)
            // ann.doShow(ann.pausedInteraction)
          } else {
            player.play()
          }
          return
        }
        leadCapture.setConfig(video.video)
        player.editReturnTime = 0
        player.startTime = time
        playback.refer_video = oldToken
        log.info(2,"🔄 VideoService branchToVideo refer_video:", playback.refer_video)
        log.info(2,"🔄 VideoService branchToVideo url:", url)
        document.title = video.video.tab_title || video.video.title
        var slug = '/w/' + video.video.token
        if (video.video.manage) {
          slug = '/videos/' + video.video.token
        } 
        log.info(2,"🔄 VideoService branchToVideo url:", url)
        if (window.location.pathname !== slug) {
          log.info(2,"🔄 VideoService branchToVideo pushing history state:", slug)
          history.pushState(null, '', slug);
        }
      }).catch((error) => {
        log.info(2,"🔴 VideoService branchToVideo show error:", error)
        player.branching = false
        ann.resetActive(null, "branchToVideo error")
        player.play()
        return
      })
      // router.push({ path: slug, replace: false })
      // window.history.pushState(video.video.tab_title || video.video.title, video.video.tab_title || video.video.title, slug)
    } catch (error) {
      log.info(2,"🔴 VideoService branchToVideo error:", error)
      player.branching = false
      ann.resetActive(null, "branchToVideo error")
      player.play()
      return
    }
  },

  /**
   * Takes a high-resolution screenshot of a video element
   * @param {HTMLVideoElement} videoElement - The video element to capture
   * @param {Object} options - Screenshot options
   * @param {number} options.scale - Scale factor for resolution (default: 1)
   * @param {string} options.type - Image type (default: 'image/png')
   * @param {number} options.quality - Image quality for jpeg (0-1, default: 0.95)
   * @returns {Promise<string>} - Returns a promise that resolves with the screenshot data URL
   */
  takeVideoScreenshot(videoElement, options = {}) {
    log.info(2,"⭐️ VideoService takeVideoScreenshot", videoElement, options)
    return new Promise((resolve, reject) => {
      // Validate input
      if (!(videoElement instanceof HTMLVideoElement)) {
        reject(new Error('First argument must be an HTMLVideoElement'));
        return;
      }

      // Default options
      const {
        scale = 1,
        type = 'image/png',
        quality = 0.8
      } = options;

      // Create canvas with scaled dimensions
      const canvas = document.createElement('canvas');
      const width = videoElement.videoWidth || videoElement.clientWidth;
      const height = videoElement.videoHeight || videoElement.clientHeight;

      canvas.width = width * scale;
      canvas.height = height * scale;

      try {
        const ctx = canvas.getContext('2d');

        // Enable image smoothing for better quality
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';

        // Check if video is ready
        if (videoElement.readyState < 2) {
          reject(new Error('Video must be loaded before taking screenshot'));
          return;
        }

        // Draw the video frame to canvas with scaling
        ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

        // Convert to data URL
        const dataURL = canvas.toDataURL(type, quality);

        // Validate the screenshot was successful
        if (dataURL === 'data:,') {
          reject(new Error('Failed to capture video screenshot'));
          return;
        }

        resolve(dataURL);
      } catch (error) {
        // Handle potential security errors (e.g., cross-origin video)
        reject(new Error(`Failed to take screenshot: ${error.message}`));
      }
    });
  }

  // Other video-related operations...
}

// Later usage in ClickComposer:
// function doVideoBranch(token) {
//   VideoService.branchToVideo(token, {
//     router,
//     player: playerStore,
//     playback: playbackStore,
//     video: videoStore
//   })
// }

// // And in AnnStore:
// doShow(ann) {
//   if (ann.type_of === 'switch' && !alreadyDone) {
//     VideoService.branchToVideo(
//       ann.click_value.split("---")[1], 
//       {
//         router: this.router,
//         player: playerStore,
//         playback: playbackStore,
//         video: videoStore
//       }
//     )
//   }
// }